import { render, staticRenderFns } from "./PurchaseInvoice.vue?vue&type=template&id=4d3dc84f"
import script from "./PurchaseInvoice.vue?vue&type=script&lang=js"
export * from "./PurchaseInvoice.vue?vue&type=script&lang=js"
import style0 from "./PurchaseInvoice.vue?vue&type=style&index=0&id=4d3dc84f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports